<template>
    <div v-if="editable" class="presetRowContainer">
        <Dropdown :items="vuexState.columns" :style="{marginRight:'25px'}" :key="keyLoader" :deleteSelected="false"
                  label="Spalte" :select-on-click="true" @enter="columnSelected" :initial="lastSelectedFilter"
                  :disabled="!editable" item-name="display_name"></Dropdown>
        <Input icon="icon-search" v-model="searchValue" label="Suchbegriff"
               :disabled="!editable" @enter="emitAdd"></Input>
        <div v-tooltip.top="'Bestätigen'">
            <unicon v-if="showAdd" name="plus" fill="#394956" hover-fill="#00B6ED" width="26px" height="26px"
                    @click="emitAdd"></unicon>
        </div>
    </div>
</template>

<script>
import Dropdown from "../../../../components/inputs/DropDown";
import Input from "../../../../components/inputs/Input";
import Utils from "../../../../scripts/utils";

export default {
    name: "PresetFilterRow",
    props: {
        columns: {
            type: Array,
            required: true,
        },
        initialize: Boolean,
        showAdd: {
            type: Boolean,
            default: true
        },
        initial: Object,
        editable: Boolean
    },
    components: {Input, Dropdown},
    data() {
        return {
            searchValue: null,
            keyLoader: 0,
            selectedColumn: null,
            dropDownInitial: null
        }
    },
    computed: {
        vuexState() {
            return this.$store.state.columns;
        },
        lastSelectedFilter() {
            return this.$store.state.presets.lastSelectedFilter ?
                this.$store.state.presets.lastSelectedFilter : this.vuexState.columns[0].name;
        }
    },
    methods: {
        columnSelected(data) {
            if (this.initialize && this.columns.findIndex(x => x.id === data.id) !== -1) {
                let json = JSON.parse(JSON.stringify(this.columns[this.columns.findIndex(x => x.id === data.id)]));
                json.pivot.filter_value = this.searchValue;
                this.selectedColumn = json;
            } else {
                if (typeof data.pivot !== "undefined" && typeof data.pivot.filter_value !== "undefined") {
                    data.pivot.filter_value = this.searchValue;
                }
                this.selectedColumn = data;
            }
            this.$store.commit('presets/updateLastSelectedFilter', {data: data.name});
        },
        emitAdd() {
            this.$emit('add', {
                column: this.selectedColumn,
                filter_value: Utils.toArray(this.searchValue)
            });
            this.searchValue = "";
        },
    },
    watch: {
        columns() {
            this.keyLoader++;
        }
    }
}
</script>

<style lang="scss" scoped>
.presetRowContainer {
    display: flex;
}

:deep(.unicon svg ){
    position: relative;
    cursor: pointer;
    margin: 10px 8px;
}

.placeholder {
    width: 30px;
    margin: 10px 8px;
}
</style>